module.exports = __webpack_public_path__ + "img/app3.a9e8ec4b.jpg";